import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import CurrencyInput from 'Components/UI/BehavioralFormElement/NormalizedInput/Currency';
import { noop, numberOrBlank } from 'Helpers/PropTypes';

const Currency = ({
  className, label, name, ...props
}) => (
  <FloatingLabel className={`Currency ${className}`} label={label} test={name}>
    <CurrencyInput className={className} name={name} {...props} />
  </FloatingLabel>
);

Currency.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: numberOrBlank,
};

Currency.defaultProps = {
  className: '',
  max: Number.POSITIVE_INFINITY,
  min: Number.NEGATIVE_INFINITY,
  onChange: noop,
  value: '',
};

export default Currency;
